module.exports = __webpack_public_path__ + "img/img2.8ce032e2.jpeg";